var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(!_vm.playing && 'visibility: hidden;')},[_c('Lottie',{attrs:{"options":_vm.lottieOptions,"width":70,"height":70},on:{"animCreated":_vm.handleCreated,"complete":_vm.handleStep}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }